import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "components/common/BreadCrumb";
import { Container } from "reactstrap";
import { toast } from "react-toastify";
import { getMaterial } from "features/Materials/services/MaterialService";
import { Material } from "features/Materials/types/material.types";
import { getDocumentTitle } from "utils/helpers";
import { MaterialCreateModal } from "./MaterialCreateModal";

/**
 * Deep-link entry for editing a material; uses the same modal as the list.
 */
const MaterialForm = () => {
  document.title = getDocumentTitle("Edit material");
  const navigate = useNavigate();
  const { id } = useParams();
  const [record, setRecord] = useState<Material | null>(null);
  const [loadingRecord, setLoadingRecord] = useState(true);

  useEffect(() => {
    if (!id) {
      setLoadingRecord(false);
      return;
    }
    let cancelled = false;
    const load = async () => {
      setLoadingRecord(true);
      try {
        const res = await getMaterial(Number(id));
        if (!cancelled && res.success) {
          setRecord(res.data);
        } else if (!cancelled) {
          toast.error("Could not load material");
          navigate("/inventory-management/materials", {
            replace: true,
          });
        }
      } catch (err) {
        console.warn(err);
        if (!cancelled) {
          toast.error("Could not load material");
          navigate("/inventory-management/materials", {
            replace: true,
          });
        }
      } finally {
        if (!cancelled) setLoadingRecord(false);
      }
    };
    void load();
    return () => {
      cancelled = true;
    };
  }, [id, navigate]);

  const listPath = "/inventory-management/materials";

  const handleClose = () => {
    navigate(listPath, { replace: true });
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Edit material"
          pageTitle="Inventory Management"
          backTo={{ label: "Materials", path: listPath }}
        />
        {loadingRecord ? (
          <p className="text-muted">Loading…</p>
        ) : record ? (
          <MaterialCreateModal
            show
            editingMaterial={record}
            onClose={handleClose}
            onSuccess={handleClose}
          />
        ) : null}
      </Container>
    </div>
  );
};

export default MaterialForm;
